import { cva } from 'class-variance-authority'

export const linkVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-black transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive cursor-pointer",
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm shadow-primary/20',
        destructive:
          'bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60 shadow-sm shadow-destructive/20',
        outline:
          'border-[1.5px] border-accent-foreground bg-background hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80 shadow-sm shadow-secondary/20',
        ghost: 'hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50',
        link: 'text-primary underline-offset-4 hover:underline',
      },
      size: {
        sm: 'h-10 rounded-[14px] px-4 gap-1.5 has-[>svg]:px-2.5',
        md: 'h-12 rounded-[18px] px-6 gap-2 has-[>svg]:px-4',
        lg: 'h-16 rounded-[24px] px-8 gap-2.5 has-[>svg]:px-6 text-lg',
        icon: 'size-12 rounded-xl',
        'icon-sm': 'size-10 rounded-lg',
        'icon-lg': 'size-16 rounded-[24px]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  },
)
